import { useInvestmentTradeConfirmAccounts } from '@egw/api'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { useMemo, type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { ListLink } from '../list-link/list-link'

export const TradeConfirmations: FC = () => {
  const { t } = useTranslation('features-documents')
  const { data, isLoading } = useInvestmentTradeConfirmAccounts()

  const brokerageData = useMemo(() => {
    if (data?.accounts) {
      return data.accounts.map((account) => ({
        name: account.accountName,
        url: WEALTH_ROUTES.DOCUMENTS_TRADE_CONFIRMATION.path.replace(':alias', account.alias.toString()),
        rank: null,
      }))
    }
    return []
  }, [data?.accounts])

  return (
    <>
      <h2 className="mb-4 mt-10 text-2xl font-semibold">{t('trade_confirmations.title')}</h2>

      {isLoading ? (
        <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
          <Skeleton count={1} height="50px" />
        </SkeletonTheme>
      ) : null}

      {!isLoading && (
        <>
          {brokerageData.map((item) => (
            <ListLink key={item.name} to={item.url} title={item.name} />
          ))}
          {!brokerageData.length && (
            <div className="bg-bglight text-body px-3 py-3.5">{t('statements.no_statements')}</div>
          )}
        </>
      )}
    </>
  )
}
